<template>
  <div style="margin:10px 0">
    <b-card border-variant="light" class="text-center">
        <p class="card-text">Status: <b>{{ has_misnomers ? 'Misnomer' : status }}</b></p>
        <b-link :to="`/alerts/${this.category}/${this.reference}/investigate`" class="card-link">{{ status === 'Under Investigation' ? 'View' : 'Begin' }} investigation</b-link>
        <b-link :to="`/alerts/${this.category}/${this.reference}/misnomer`" class="card-link">{{ has_misnomers ? 'Manage/unflag misnomer' : 'Flag as a misnomer' }}</b-link>
    </b-card>
  </div>
</template>

<script>
export default {
  props: ['category', 'status', 'reference', 'misnomers'],
  computed: {
    has_misnomers() {
      return this.misnomers.length > 0;
    }
  }
};
</script>
